
import * as Yup from "yup";


export const getInitialValues = (): any => {
 

  return {
    password: "",
    email:""
  }


};

export const getValidationSchema = (editMode: boolean = false): Yup.Schema<any> => {
    // validate input  
  return Yup.object().shape({
    email:Yup.string().required("required"),
    password:Yup.string().required("required"),

  });
};